const STALE_BUNDLE_MESSAGES = [
    /loading chunk .* failed/i,
    /failed to fetch dynamically imported module/i
];
const hasStaleBundleMessage = (message)=>typeof message === 'string' && STALE_BUNDLE_MESSAGES.some((pattern)=>pattern.test(message));
export const STALE_BUNDLE_RELOAD_MARKER = 'anchor.staleBundleReloaded';
export const isStaleBundleError = (error)=>{
    const candidate = error;
    return (candidate === null || candidate === void 0 ? void 0 : candidate.name) === 'ChunkLoadError' || hasStaleBundleMessage(candidate === null || candidate === void 0 ? void 0 : candidate.message);
};
export const shouldReloadForStaleBundle = (error, alreadyReloaded)=>isStaleBundleError(error) && !alreadyReloaded;
